import { render } from "./HomeAboutPanel.vue?vue&type=template&id=5f7ba324&bindings={\"isLoading\":\"setup\",\"content\":\"setup\"}"
import script from "./HomeAboutPanel.vue?vue&type=script&lang=js"
export * from "./HomeAboutPanel.vue?vue&type=script&lang=js"
script.render = render

export default script